import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { UzurvFilterDefinition } from '@uzurv/http';
import { isNullOrUndefined } from '@uzurv/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnChanges {
  @Input() title = '';

  @Input() filters: Array<UzurvFilterDefinition> = [];

  @Output() filtersChangedHandler: EventEmitter<Array<UzurvFilterDefinition>> = new EventEmitter();

  @ViewChild('searchForm', { static: true }) searchForm: NgForm;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges() {}

  search() {
    this.filtersChangedHandler.emit(this.filters);
  }

  clearFilter(filter: UzurvFilterDefinition) {
    filter.value = null;
    this.search();
  }

  handleDatePickerChange(filter: UzurvFilterDefinition, event: MatDatepickerInputEvent<Date>) {
    if (!isNullOrUndefined(event.value)) {
      filter.value = event.value;
      this.changeDetectorRef.detectChanges();
    }
  }
}
